import React from "react"
import styled from "styled-components"
import Container from "./Container"
import Link from "gatsby-link"
import Button from './Button';

const FooterWrapper = styled.div`
  color: ${props => props.theme.colors.black};
  padding-top: 3rem;
  margin-bottom: 1rem;
  position: relative;
  &:after {
    content: "";
    height: 1rem;
    width: 100%;
    position: absolute;
    bottom: -1rem;
    left: 0;
    background: ${props => props.theme.gradients.red};
  }
  section {
    width: 1020px;
    max-width: 100%;
    justify-content: space-between;
    flex-wrap: wrap;
    .copy {
      width: 100%;
      text-align: center;
      margin-top: 4rem;
      margin-bottom: 2rem;
      a {
        color: ${props => props.theme.colors.black};
        font-weight: 500;
        text-decoration: none;
        position: relative;
        transition: all 0.3s ease;
        padding: 0.2rem 0.4rem;
        z-index: 10;
        &:hover {
          color: #fff;
          &::before {
            height: 100%;
            width: 100%;
            opacity: 1;
          }
        }
        &:before {
          z-index: -1;
          content: "";
          position: absolute;
          height: 0%;
          width: 100%;
          bottom: -1px;
          left: 0;
          opacity: 1;
          transition: all 0.3s ease;
          background: ${props => props.theme.gradients.red};
        }
      }
    }
    .left {
      width: 555px;
      max-width: 100%;
      h4 {
        font-size: 2.5rem;
        line-height: 4rem;
        @media screen and (max-width: 724px) {
          font-size: 3rem;
          line-height: 4.3rem;
        }
      }
    }
    .right {
      @media screen and (max-width: 724px) {
        ul {
          margin-top: 3rem;
        }
      }
      ul {
        padding-left: 1.75rem;
      }
      li {
        margin-bottom: 1rem;
        position: relative;
       
      }
      a {
        text-transform: uppercase;
        color: ${props => props.theme.colors.black};
        letter-spacing: 0.5px;
        position: relative;
        text-decoration: none;
        transition: all 0.3s ease;
        padding: 0.2rem 0.4rem;
        z-index: 10;
        &:hover {
          color: ${props => props.theme.colors.blue};
          &::before {
            height: 10%;
            width: 100%;
            opacity: 1;
          }
        }
        &:before {
          z-index: -1;
          content: "";
          position: absolute;
          height: 10%;
          width: 0%;
          bottom: -1px;
          left: 0;
          opacity: 1;
          transition: all 0.3s ease;
          background: ${props => props.theme.gradients.red};
        }
      }
    }
  }
`

const Footer = () => (
  <FooterWrapper>
    <Container>
      <div className="left">
        <h4>
          Konya İnşaat Firması İhtiyacınız Mı Var ?
        </h4>
        <p>Bütçeye uygun en nitelikli yaşam alanlarını, en uygun koşullarla sunmayı amaçlayan, sektörün yenilik ve güncel gelişmelerini takip eden dinamik bir yapıya sahibiz. Çalışma prensibimiz güven ve çok çalışmaktır.</p>
        <Link to="/iletisim">
          <Button type="link" link="/iletisim" text="İLETİŞİME GEÇ" />
        </Link>
      </div>
      <div className="right">
        <ul>
          <li>
            <a
              target="blank"
              rel="noopener noreferrer"
              href="https://www.instagram.com/ayazsan_insaat"
            >
              INSTAGRAM
            </a>
          </li>
          <li>
            <a
              target="blank"
              rel="noopener noreferrer"
              href="https://www.twitter.com/"
            >
              Twitter
            </a>
          </li>
          <li>
            <a
              target="blank"
              rel="noopener noreferrer"
              href="https://www.linkedin.com/"
            >
              LinkedIn
            </a>
          </li>
          <li>
            <a
              target="blank"
              rel="noopener noreferrer"
              href="https://www.facebook.com/konyainsaatyapi"
            >
              Facebook
            </a>
          </li>
          <li>
            <a
              target="blank"
              rel="noopener noreferrer"
              href="https://youtube.com/"
            >
              YOUTUBE
            </a>
          </li>
        </ul>
      </div>
      <div className="copy">
        <span>
          {new Date().getFullYear()} Copyright &copy; AYAZSAN | Web Tasarım &amp; SEO − {' '}
          <a target="blank"
            rel="noopener noreferrer"
            href="https://zahidkarakaya.com/">
            <strong>Zahid Karakaya</strong>
          </a>
        </span>
      </div>
    </Container>
  </FooterWrapper>
)

export default Footer
